import type { FC, MouseEventHandler } from 'react';
import React, { useState } from 'react';
import {
  Body,
  Box,
  Col,
  Flex,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';
import { Trans, useTranslation } from '@edreamsodigeo/frontend-core';

import ConnectionInsuranceModalMapItinerary from './ConnectionInsuranceModalMapItinerary';
import type { ConnectionInsuranceMapItineraryProps } from '@/components/FlightSummary/MapItinerary/types';

const LinkComponent: FC<{ handleOpen?: MouseEventHandler<HTMLDivElement> }> = ({
  children,
  handleOpen,
}) => {
  return (
    <Box display="inline">
      <Box
        borderBottom="dotted"
        borderBottomWidth={1}
        borderColor="primary.50"
        display="inline"
      >
        <Body type="xSmall" color="primary.50" inline onClick={handleOpen}>
          {children}
        </Body>
      </Box>
    </Box>
  );
};

const NEUTRAL_80 = 'neutral.80';
const TextByPolicy: FC<ConnectionInsuranceMapItineraryProps> = ({
  policy,
  carrier,
  handleOpen,
}) => {
  const { t } = useTranslation();
  return policy !== 'CARRIER_GUARANTEE' ? (
    <Box pl="1x_small">
      <Body type="xSmall" color={NEUTRAL_80}>
        <Trans
          i18nKey="flightSummary.itinerary.stop.insuranceHub"
          values={{
            insuranceName: t('flightsummary.itinerary.missed.connection.title'),
          }}
          components={{
            insuranceName: <LinkComponent handleOpen={handleOpen} />,
          }}
        />
      </Body>
    </Box>
  ) : (
    <Box pl="1x_small">
      <Body type="xSmall" color={NEUTRAL_80}>
        {t('flightSummary.itinerary.stop.missedConnection', {
          carrierName: carrier.name,
        })}
      </Body>
    </Box>
  );
};

const ConnectionInsuranceMapItinerary: FC<
  ConnectionInsuranceMapItineraryProps
> = ({ policy, carrier }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = (): void => {
    setOpen(!open);
  };

  return (
    <>
      <Box>
        <Flex flexDirection="row">
          <Col>
            <Glyph
              size="small"
              color={NEUTRAL_80}
              category="Security"
              name="ShieldInsurance"
            />
          </Col>
          <Col>
            <TextByPolicy
              policy={policy}
              carrier={carrier}
              handleOpen={handleOpen}
            />
          </Col>
        </Flex>
        <ConnectionInsuranceModalMapItinerary
          open={open}
          handleClose={handleOpen}
          policy={policy}
        />
      </Box>
    </>
  );
};

export default ConnectionInsuranceMapItinerary;
